import React, { useState, useEffect, useRef } from 'react';
import Swiper from 'react-id-swiper';
import InfluencerPill from 'shared/influencer-pill';
import s from './infl-swiper.module.scss';

export default function InfluencerSwiper({ influencers, ...props }) {
  const swiper = useRef();
  const [ready, setReady] = useState(false);
  // eslint-disable-next-line no-return-assign
  const updateSwiper = mySwiper => (swiper.current = mySwiper);

  const handleResize = () => {
    if (swiper && swiper.current) {
      swiper.current.update();
    }
  };

  /*
  wait for swiper to initialize then add opacity to wrapper
  to prevent seeing the breakpoint transition
  */
  useEffect(() => {
    if (swiper && swiper.current) {
      setReady(true);
    }
  }, [swiper]);

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const params = {
    breakpointsInverse: true,
    slidesPerView: 'auto',
    breakpoints: {
      767: {
        slidesPerView: 'auto'
      }
    },
    spaceBetween: 10,
    loop: influencers.length > 5,
    loopedSlides: 0,
    preloadImages: false,
    speed: 5000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false
    }
  };

  return (
    <div className={`${s.root} ${ready ? s.ready : ''}`}>
      <div className={s.swiperContainer}>
        <div className={s.swiperWrapper}>
          <Swiper getSwiper={updateSwiper} {...params}>
            {influencers
              .sort(() => Math.random() * 2 - 1)
              .map((el, i) => (
                <div className={s.pillWrapper} key={`${el.name}-${i}`}>
                  <InfluencerPill {...el} />
                </div>
              ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
}
